<template>
    <v-container class="recover-password-container" fluid fill-height>
        <v-flex>
            <v-form @submit.prevent="recoverPassword">
                <v-card class="elevation-0 pa-5">
                    <v-card-text>
                        <p class="mt-7 mb-9">Per recuperare la password, inserisci lo username oppure l'email nel campo sottostante.<br> Se il dato inserito è presente nel database, riceverai un'email con le istruzioni per completare il recupero.</p>
                        <v-text-field outlined id="emailOrUsername" name="emailOrUsername" placeholder="Email o Username" type="text" v-model="username"></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn rounded x-large color="primary" type="submit" :loading="loading" :disabled="!username || loading" width="100%">IMPOSTA PASSWORD</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-flex>
    </v-container>
</template>

<script>

import UserService from "@/service/UserService";

const userService = new UserService();

export default {
    name: "RecoverPassword",
    data: () => ({
        loading: false,
        username: null
    }),
    methods: {
        recoverPassword: function () {
            this.loading = true;
            userService.recoverPassword(this.username).then(() => {
                this.$router.push(`/recover-password-success`);
            }, error => {
                this.$root.showError(error.response.data.message, error.response.data);
            }).finally(() => {
                this.loading = false;
            });
        }
    }
}
</script>

